exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container{padding:0 5px;margin:0 5px}h3.title{margin:0;padding-top:5px;padding-bottom:5px;text-align:center}.code{padding:20px;text-align:left;font-family:monospace;background-color:#2e2e2e;color:#bbb}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./script/shared/usecase/component.css
 ** module id = 370
 ** module chunks = 0 1
 **/